// Bump when replacing files in public/dashboard/images/integrations
// (production Cache-Control is 1 year).
export const INTEGRATION_LOGO_VERSION = '2';

export const integrationLogoUrl = (id, { dark = false } = {}) => {
  const suffix = dark ? '-dark' : '';
  return `/dashboard/images/integrations/${id}${suffix}.png?v=${INTEGRATION_LOGO_VERSION}`;
};
